import wrapPage from "./src/wrap-page"
export const wrapPageElement = wrapPage
